export const PREMIUM_SUCCESS_URL = {
  PATH: 'https://www.wix.com/ai-create-store/upgrade-complete',
  SEARCH_PARAM: 'premium',
  SEARCH_VALUE: 'purchaseComplete'
};
export const PREMIUM_PRODUCT_TYPE_ID = '8b1b47e6-9f58-4e59-b147-cac894bec8da';
export const PRODUCT_FAMILY_ID = '1e543668-731b-4ec3-aaff-560dbca7ed69';
export const PURCHASE_TYPE = 'sunrise';
//# sourceMappingURL=consts.js.map